import {
  Building2,
  FileCheck2,
  Car,
  LandPlot,
  TreePine,
  Hammer,
  Layers,
  Home,
  Dumbbell,
  Gamepad2,
  Film,
  Coffee,
  Waves,
  Activity,
  Map,
  Leaf
} from "lucide-react";
import p1 from "../assets/images/projects/img.jpg";
import p2 from "../assets/images/projects/img1.jpg";
import p3 from "../assets/images/projects/img2.webp";
import p4 from "../assets/images/projects/img3.jpg";
import p5 from "../assets/images/projects/img4.png";

import p11 from "../assets/images/projects/project11.jpg";
import p12 from "../assets/images/projects/project12.jpg";

import p13 from "../assets/images/projects/Project13.jpg";
import p14 from "../assets/images/projects/Aminites1.jpg";
import p15 from "../assets/images/projects/Aminites2.jpg";
//sattava
import s1 from "../assets/images/projects/sattva1.jpeg";
import s2 from "../assets/images/projects/sattva2.jpeg";
//sattava aminitis

import s3 from "../assets/images/projects/Sattva_Gym_Hires.jpg";
import s4 from "../assets/images/projects/Sattva_Indoor_Games_Hires.jpg";
import s5 from "../assets/images/projects/Pool Cam.jpg";
import s6 from "../assets/images/projects/MultiPurpose_Hall_Hires.jpg";
//birla
import b1 from "../assets/images/projects/Birlathirmaya1.jpeg";

//Brigade
import bg1 from "../assets/images/projects/BrigadeEbony1.jpeg";
import bg2 from "../assets/images/projects/brigadeEbony2.webp";

import bga1 from "../assets/images/projects/BrigadeEbonyAminites1.jpg";
import bga2 from "../assets/images/projects/BrigadeEbonyAminites2.jpeg";
import bga3 from "../assets/images/projects/BrigadeEbonyAminites3.jpeg";
import bga4 from "../assets/images/projects/BrigadeEbonyAminites4.png";
//Lodha

import ld1 from "../assets/images/projects/Lodha1.jpeg";

import ld2 from "../assets/images/projects/Lodha2.jpg";
import la3 from "../assets/images/projects/LodhaAminitis1.jpg";
import la4 from "../assets/images/projects/LodhaAminites2.jpg";

import la5 from "../assets/images/projects/lodhaAminities3.jpg";

//kns infra

import kns1 from "../assets/images/projects/Kns1.jpg";
import kns2 from "../assets/images/projects/Kns2.jpg";

import knsA1 from "../assets/images/projects/KnsAminitis1.webp";
import knsA2 from "../assets/images/projects/KnsAminitis2.webp";

import knsA3 from "../assets/images/projects/KnsAminitis3.webp";

import knsA4 from "../assets/images/projects/KnsAminitis4.webp";

//GodrejParkshire

import go1 from "../assets/images/projects/GodrejParkshire11.webp";
import goa2 from "../assets/images/projects/GodrejParkshire.webp";

import goa3 from "../assets/images/projects/GodrejParkshire1.webp";
import goa4 from "../assets/images/projects/GodrejParkshire3.webp";

import goa5 from "../assets/images/projects/GodrejParkshire4.webp";

import go12 from "../assets/images/projects/GodrejParkshire12.webp";

//Century Regalia’s

import Century1 from "../assets/images/projects/century-regalia-indira-nagar.jpg";
import Century2 from "../assets/images/projects/Century2.jpg";
import Century3 from "../assets/images/projects/CenturyAminites1.jpg";
import Century4 from "../assets/images/projects/CentruyAminities2.jpg";
import Century5 from "../assets/images/projects/centuryAminities3.jpg";
import Century6 from "../assets/images/projects/CentruryAminities.4.jpg";
// con Concorde Neo

import ConcordeNeo1 from "../assets/images/projects/Concorde.webp";
import ConcordeNeo2 from "../assets/images/projects/Concorde2.webp";
import ConcordeNeo3 from "../assets/images/projects/ConcordeAminities1.webp";


import Assets1 from "../assets/images/projects/Assetz Zen & Sato (1).webp";
import Assets2 from "../assets/images/projects/Assetz1.webp";
import Assets3 from "../assets/images/projects/Assetz Zen & Sato (3).webp";
import Assets4 from "../assets/images/projects/Assetz Zen & Sato (4).webp";

//puvankar 
import puvankar1 from "../assets/images/projects/Purvanakar2.webp";
import puvankar2 from "../assets/images/projects/Purvankar.webp";

import puvankarAminities1 from "../assets/images/projects/purvanakaraminities1.webp";
import puvankarAminities2 from "../assets/images/projects/purvanakaraminities2.webp";

import puvankarAminities3 from "../assets/images/projects/purvanakaraminities3.webp";
import puvankarAminities4 from "../assets/images/projects/purvanakaraminities4.webp";
//shoba

import Shoba1 from "../assets/images/projects/Shoba1.jpeg";

 import Shoba2 from "../assets/images/projects/Shobalatestproject3.jpg";
 //Prestige rain tree phase 2



import Prestige1 from "../assets/images/projects/Prestige1.jpeg";

 import Prestige2 from "../assets/images/projects/Prestige2.jpeg";


 import Prestigeamenities1 from "../assets/images/projects/pristageaminities1.jpeg";

 import Prestigeamenities2 from "../assets/images/projects/Pristage.aminitis.jpeg";
  import Prestigeamenities3 from "../assets/images/projects/Pristage.aminitis3.jpeg";
 import Vaishnavidevi1 from "../assets/images/projects/Vaishnavidevi.jpeg";



 //Ligacy-mihira


 import LigacyMihira1 from "../assets/images/projects/Ligacy-mihira1.jpeg";

 import LigacyMihira2 from "../assets/images/projects/Ligacy-mihira2.jpeg";
  import LigacyMihira3 from "../assets/images/projects/Ligacy-mihira3.jpeg";
 import LigacyMihira4 from "../assets/images/projects/Ligacy-mihira4.jpeg";



import Brochure1 from "../assets/Brochure/EmbassyGreenshoreBrochure.pdf";

export const ICONS = {
  Building2,
  FileCheck2,
  Car,
  LandPlot,
  TreePine,
  Hammer,
  Layers,
  Home,
  Dumbbell,
  Gamepad2,
  Film,
  Coffee,
  Waves,
  Activity,
  Map,
  Leaf
};

export const projects = [
  //sattva 1
    {
    slug: "jayram-serenity-studio",
    title: "Sattva Lavita",
    location: "Hennur Main Road",
    image: s2,
    topTag: "Possession: September, 2026",
    imageTag: "Premium",
    status: "Featured",
    statusType: "offplan",
    img: [s1, s3, s4, s5, s6],
    Brochure: [Brochure1],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Sattva La Vita is a premium villa plot project by Sattva Group, located near Hennur–Bagalur Road in North Bangalore, close to the upcoming growth corridor towards the Airport and KIADB Aerospace Park. The project offers well-planned residential plots designed for independent luxury villas within a secure gated community.",

        "It features wide internal roads, landscaped gardens, parks, clubhouse facilities, walking tracks, and modern infrastructure like underground cabling, water supply, and drainage systems.",

        "Due to its proximity to Manyata Tech Park, Bhartiya City, international schools, hospitals, and the upcoming metro connectivity, Sattva La Vita has become a popular choice for both investors and end-users looking for peaceful living with strong future appreciation potential."
      ]
    },

    // 🔹 PROJECT DESCRIPTION SECTION
    description: {
      intro:
        "Salarpuria Sattva La Vita features the very best in Sattva Group’s luxury segment.",

      highlights: ["B + G + 2Floors", "4 BHK Row Houses"],

      configurations: ["4 BHK Row Houses"],

      price: "5.53 Cr onwards"
    },
    summary: [
      { label: "Project Name", value: "Sattva La Vita", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1251/446/PR/ 041223/006446",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Salarpuria Sattva", icon: "Home" },
      { label: "Structure Type", value: "B + G + 2Floors", icon: "Car" },
      { label: "Total Land Area", value: "3Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "53.21%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "2", icon: "Layers" },
      { label: "Units", value: "63", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & multipurpose hall"
          },
          {
            icon: "Film",
            title: "Private Theatre",
            desc: "Private cinema experience"
          },
          { icon: "Coffee", title: "Tabel Tennies", desc: "Tennies Tennies" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          { icon: "Waves", title: "Swimming Pool", desc: "Adult & kids pool" },
          {
            icon: "Activity",
            title: "Sports Courts",
            desc: "Tabel Tennis & basketball & Cricket Pitch"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  },






   {
    slug: "Ligacy-mihira",
    title: "Ligacy Mihira",
    location: "Devanahalli",
    image: LigacyMihira2,
    topTag: "Possession: December 2030",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [LigacyMihira1, LigacyMihira2, LigacyMihira3, LigacyMihira4],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Legacy Mihira is a thoughtfully designed residential project that blends modern living with serene surroundings, offering a perfect balance of comfort, elegance, and convenience.",

        " Strategically located in a well-connected neighborhood, the project ensures easy access to major IT hubs, educational institutions, healthcare facilities, and lifestyle destinations. Crafted with attention to detail, Legacy Mihira features well-planned homes with spacious layouts, ample natural light, and premium finishes to elevate everyday living.",
        "Residents can enjoy a host of contemporary amenities including landscaped gardens, a clubhouse, fitness center, children’s play area, and recreational spaces, creating a vibrant and community-driven lifestyle.",
        "With its focus on quality construction and a peaceful environment, Legacy Mihira is an ideal choice for families and investors seeking long-term value and a refined urban lifestyle."
      ]
    },
    description: {
      intro:
        "The residential enclave Lodha Mirabelle Phase 2 features the very best in Lodha Group’s luxury living segment",

      highlights: [
        "Flotted Developement",
        "22 Acres Of Thoughtful Living in Devanahalli",
      ],

      configurations: [
        "1200 Sq Ft(111 sqm) ",
        "1500 sq ft (139 sqm)",
        "1800 sq ft(167 sqm) ",
        "	2264 sq ft (210 sqm)",
        "2400 sq ft(223 sqm) ",
        "3500 sq ft (325 sqm)",
      ],

      price: "96 lakh onwards"
    },
    summary: [
      { label: "Project Name", value: "Lodha Mirabelle", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1250/303/PR/220725/007945",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Legacy ", icon: "Home" },
      { label: "Structure Type", value: "Plotted development", icon: "Car" },
      { label: "Total Land Area", value: "22 Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "50%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Flot Area", value: "1200 - 3500", icon: "Layers" },
      // { label: "Units", value: "284", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & multipurpose hall"
          },
          {
            icon: "Film",
            title: "security",
            desc: "24/7 security and CCTV monitoring"
          },
          { icon: "Coffee", title: "Tabel Tennies", desc: "Tennies Tennies" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          { icon: "Waves", title: "Swimming Pool", desc: "Adult & kids pool" },
          {
            icon: "Activity",
            title: "Sports Courts",
            desc: "Badminton & basketball"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "halls",
            desc: "entertainment lounges, a banquet halls"
          }
        ]
      }
    ]
  },
   {
    slug: "lodha-heven",
    title: "Lodha Mirabelle",
    location: "Manyata Tech Park, Thanisandra",
    image: ld1,
    topTag: "Possession: December 2030",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [ld2, la3, la4, la5],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "The residential enclave Lodha Mirabelle Phase 2 features the very best in Lodha Group’s luxury living segment. The project offers spacious and fine-crafted 3.5 BHK and 4 BHK Apartments with luxurious features.",

        "Beautiful landscapes around Lodha Mirabelle Phase 2 (Lodha Manyata Tech Park) with plenty of green covers, 3.2 acres of central gardens, and over 80% open spaces make it more special and elite.",
        "The renowned builder, Lodha Group, is guaranteed to bring a quality living experience to the community of the 125-acre Manyata Tech Park, Thanisandra, Nagavara, Hebbal, North Bangalore with brilliant architecture and an equivalent lifestyle in Lodha at Manyata Tech Park."
      ]
    },
    description: {
      intro:
        "The residential enclave Lodha Mirabelle Phase 2 features the very best in Lodha Group’s luxury living segment",

      highlights: [
        "G + 39 Floors",
        "2Towers across 19.3 Acres",
        "Spacious 3.5 & 4 BHK Residences"
      ],

      configurations: ["3.5 BHK – 2340 Onwards sft", "4 BHK 2952 Onwards sft"],

      price: "2.6 Cr onwards"
    },
    summary: [
      { label: "Project Name", value: "Lodha Mirabelle", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1251/446/PR/230425/007688",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Lodha ", icon: "Home" },
      { label: "Structure Type", value: " G + 39 Floors 2Towers", icon: "Car" },
      { label: "Total Land Area", value: "19.3Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "80%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "39", icon: "Layers" },
      { label: "Units", value: "284", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & multipurpose hall"
          },
          {
            icon: "Film",
            title: "Private Theatre",
            desc: "Private cinema experience"
          },
          { icon: "Coffee", title: "Tabel Tennies", desc: "Tennies Tennies" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          { icon: "Waves", title: "Swimming Pool", desc: "Adult & kids pool" },
          {
            icon: "Activity",
            title: "Sports Courts",
            desc: "Badminton & basketball"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Party Hall Malls",
            desc: "MultiPurpose Party A    rea"
          }
        ]
      }
    ]
  },
  //shoba 2

  {
    slug: "Sobha-World-city",
    title: "Sobha World City ",
    location: "Panathur Marathahalli",
    image: Shoba1,
    topTag: "Possession:June 2028 ",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [Shoba2,puvankarAminities3,puvankarAminities4,p14, p15],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Shoba Neopolis, an address that redefines modern living with elegance, comfort, and thoughtful design. Nestled in one of the most promising and well-connected neighborhoods, Shoba Neopolis offers a perfect blend of contemporary architecture, premium amenities, and serene surroundings. ",

        " Every residence is crafted with meticulous attention to detail, featuring spacious layouts, abundant natural light, high-quality finishes, and smart design elements that elevate everyday living.",
        "Designed for those who seek both convenience and sophistication, Shoba Neopolis provides world-class amenities including landscaped gardens, a modern clubhouse, fitness center, swimming pool, children’s play areas, and dedicated spaces for relaxation and recreation.",
        "With seamless connectivity to key business hubs, educational institutions, healthcare facilities, and entertainment zones, residents enjoy the perfect balance of urban accessibility and peaceful retreat."
      ] 
    },
    description: {                  
      intro:
        "Shoba Neopolis – Where Luxury Meets Lifestyle At Shoba Neopolis, every moment is designed to inspire a refined lifestyle—where comfort, community, and luxury come together to create a truly exceptional living experien",

      highlights: [
        "2B + G  + 18Floors ",
        " 8 Towers across  25.38  Acres",
        "2,3,4 BHK + M"
      ],

      configurations: ["3 BHK  1,1611++   sq.ft.",   "4 BHK 2,481 sq.ft.",],

      price: "2.3 Cr onwards"
    },
    summary: [                                                                          
      { label: "Project Name", value: "Shoba Neopolis", icon: "Building2" },
      {
        label: "RERA No",
        value: "RERA NO:  PRM/KA/RERA/1251/446/PR/200923/006271",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Shoba Proparties", icon: "Home" },
      {
        label: "Structure Type",
        value: "2B + G  + 18Floors ",
        icon: "Car"
      },
      { label: "Total Land Area", value: "25.38", icon: "LandPlot" },
      { label: "Open Space Area", value: "74%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "2B + G + 18", icon: "Layers" },
      { label: "Units", value: "1875", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & Tabel Tennis caroom , Pickleball, Badminton"
          },
          {
            icon: "Film",
            title: "Theatre",
            desc: "AmphiTheatre"
          },
          { icon: "Coffee", title: "Lawn Terraces", desc: "Lawn Terraces " }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          {
            icon: "Waves",
            title: "Swimming Pool",
            desc: "Lush swimming pool with water features"
          },
          {
            icon: "Activity",
            title: "Park",
            desc: "Kid's Play Area & Seating Pavillon, Pet Park ,Treehouse Walk ,Climbing Wall,Play Zone,Hobbit House"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  } ,
   {
    slug: "jayram-green-county-18mk",
    title: "Embassy Green Shore",
    location: "Devanahalli",
    image: p11,
    projects: "Embassy Green Shore",
    topTag: "Possession: December 30, 2031",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    img: [p12, p13, p14, p15],
    Brochure: [Brochure1],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Embassy Greenshore is a premium residential development located within the prestigious Embassy Springs Township in Devanahalli, North Bengaluru, near Kempegowda International Airport.",

        "Developed by the renowned Embassy Group, the project offers thoughtfully designed homes set amidst landscaped greenery and a peaceful lakeside environment. Embassy Greenshore combines modern architecture with township living, providing both privacy and a vibrant community lifestyle.",

        "Residents enjoy world-class amenities including a clubhouse, swimming pool, gymnasium, indoor & outdoor sports courts, jogging tracks, children’s play areas, landscaped gardens, and access to a self-sustained ecosystem with schools, healthcare, retail, parks, and a central lake."
      ]
    },

    // 🔹 PROJECT DESCRIPTION SECTION
    description: {
      intro:
        "Embassy Springs is one of the largest integrated township developments in North Bangalore.",

      highlights: [
        "2B + G + 18 Floors",
        "8 Towers across 14 Acres",
        "Spacious 2, 3 & 4 BHK Residences"
      ],

      configurations: [
        "2 BHK – 1200 sft",
        "3 BHK – 1750–1850 sft",
        "4 BHK – 2200–2600 sft"
      ],

      price: "1.35 Cr onwards"
    },
    summary: [
      {
        label: "Project Name",
        value: "Embassy Green Shore",
        icon: "Building2"
      },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1250/303/PR/201125/00826",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Embassy Springs", icon: "Home" },
      { label: "Structure Type", value: "2B + G + 18 Floors", icon: "Car" },
      { label: "Total Land Area", value: "14 Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "75%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "18", icon: "Layers" },
      { label: "Units", value: "878", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & multipurpose hall"
          },
          {
            icon: "Film",
            title: "Mini Theatre",
            desc: "Private cinema experience"
          },
          { icon: "Coffee", title: "Terrace Café", desc: "Casual dining space" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          { icon: "Waves", title: "Swimming Pool", desc: "Adult & kids pool" },
          {
            icon: "Activity",
            title: "Sports Courts",
            desc: "Badminton & basketball"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  },
    {
    slug: "Prestige-rain-tree-phase2",
    title: "Prestige RainTree Phase 2",
    location: "Panathur Marathahalli",
    image: Prestige1,
    topTag: "Possession:June 2028",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [Prestige2,Prestigeamenities3,Prestigeamenities1,Prestigeamenities2],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Prestige Rain Tree Park Phase 2 is a premium residential development by the renowned Prestige Group, designed to offer a perfect blend of luxury, comfort, and nature-inspired living.",

        " Strategically located in a well-connected neighborhood, this thoughtfully planned community features spacious and elegantly crafted apartments with contemporary architecture and high-quality finishes. ",
        "Every home is designed to maximize natural light, ventilation, and privacy, ensuring a refreshing and comfortable lifestyle for residents.",
        "Phase 2 continues the legacy of excellence with world-class amenities such as a grand clubhouse, swimming pool, landscaped gardens, fitness center, children’s play area, jogging tracks, and dedicated sports facilities.",
        "The project emphasizes green open spaces and serene surroundings, creating a peaceful retreat from the city’s hustle while keeping you close to major IT hubs, educational institutions, healthcare centers, and entertainment zones."
      ] 
    },
    description: {                  
      intro:"Prestige Rain Tree Park Phase 2 is a premium residential development by the renowned Prestige Group, designed to offer a perfect blend of luxury, comfort, and nature-inspired living.",
      highlights: [
        "3B + G+  + 19Floors ",
        "14 Towers across  24  Acres",
        "2,3,4 BHK + M"
      ],

      configurations: ["2 BHK  1,200 sq.ft.",   "3 BHK 1,500 -2015 sq.ft." , "4 BHK 2300-2500 sq.ft",],

      price: "1.8 Cr onwards"
    },
    summary: [                                                                          
      { label: "Project Name", value: "Prestige rain tree phase 2", icon: "Building2" },
      {
        label: "RERA No",
        value: "RERA NO:  PRM/KA/RERA/1251/446/AG/230412/003574",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Prestige", icon: "Home" },
      {
        label: "Structure Type",
        value: "3B + G+  + 19Floors ",
        icon: "Car"
      },
      { label: "Total Land Area", value: "24", icon: "LandPlot" },
      { label: "Open Space Area", value: "80%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "3B + G+  + 19Floors ", icon: "Layers" },
      { label: "Units", value: "2000", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & Tabel Tennis caroom , Pickleball, Badminton"
          },
          {
            icon: "Film",
            title: "Ev Station",
            desc: "EV Charging"
          },
          { icon: "Coffee", title: "Lawn Terraces", desc: "Lawn Terraces " }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          {
            icon: "Waves",
            title: "Swimming Pool",
            desc: "Lush swimming pool with water features"
          },
          {
            icon: "Activity",
            title: "Park",
            desc: "Kid's Play Area & Seating Pavillon, Pet Park ,Treehouse Walk ,Climbing Wall,Play Zone,Hobbit House"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  } ,
  //jayram
 
  //kns

   {
    slug: "kns-infra",
    title: "KNS Samooha",
    location: "Nelmangala",
    image: kns1,
    topTag: "Possession: December 2026",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [kns2, knsA1, knsA2, knsA3, knsA4],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "KNS Infrastructure has been a pioneer in residential plotted development projects since 2007 with over 25 million squarefeet of developed & delivered layouts under our hat, we are the avant-garde of the plotted development market",

        "We believe every property purchase is just a beginning of an extraordinary story, a story of achieving goals, realising one’s dreams, a story of a secure future and most of all a story of happiness at every squarefeet,at KNS , we acknowledge that story & the journey towards a secure future; & this is the vision with which we strive to create some of the best products in class and serve our customers exceptionally with diligence, transparency and on time delivery."
      ]
    },
    description: {
      intro:
        "KNS Infrastructure has been a pioneer in residential plotted development projects since 2007 with over 25 million squarefeet of developed & delivered layouts under our hat, we are the avant-garde of the plotted development market",

      highlights: ["Plotted Development", "170+ Acres Phase 1/2/3"],

      configurations: [
        "30*40 – 	1200 Sq Ft ",
        "30*45 	1350 sq ft",
        "30*50– 	1500 sq ft ",
        "40*60 	2400 sq ft"
      ],

      price: "69 Lakh onwards"
    },
    summary: [
      { label: "Project Name", value: "Kns Samooha", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1250/307/PR/060325/007551",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Kns infra ", icon: "Home" },
      { label: "Structure Type", value: "Plotted Development", icon: "Car" },
      { label: "Total Land Area", value: "175+ Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "48%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Number of Amenities", value: "50+", icon: "Hammer" },

      { label: "Units", value: "2500+", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym &  Outdoor fitness & Yoga Pavillon"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & multipurpose hall"
          },
          { icon: "Film", title: "Garden ", desc: "Bamboo && Tropical Garden" },
          { icon: "Coffee", title: "Tabel Tennies", desc: "Tennies Tennies" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          { icon: "Waves", title: "Swimming Pool", desc: "Adult & kids pool" },
          {
            icon: "Activity",
            title: "Sports Courts",
            desc: "Volly Ball &  Basket Ball Skating Zoan"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Party Hall Malls",
            desc: "MultiPurpose Party AArea  "
          }
        ]
      }
    ]
  },
 

  //Birla
  {
    slug: "jayram-gardenia-villa",
    title: "Birla Trimaya  Phase 2 ",
    location: "Shettigere , Airport Road ",
    image: b1,
    topTag: "Handover: 2029 Onwards",
    imageTag: "Premium",
    status: "Ready",
    statusType: "ready",
    img: [p12, p13, p14, p15],
    Brochure: [Brochure1],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "  Birla Trimaya Phase 2 is a premium integrated township by Birla Estates located in the fast-growing Devanahalli–Shettigere corridor of North Bangalore, just minutes from Kempegowda International Airport.",

        " Spread across a vast green landscape, the project offers thoughtfully planned apartments, duplex homes and villaments designed with modern architecture, abundant ventilation and natural light",

        "With excellent connectivity to Bellary Road (NH-44), upcoming metro line, IT parks and business hubs, Birla Trimaya Phase 2 is ideal for both end-use living and long-term investment, combining luxury living with the trust and quality of the Birla brand"
      ]
    },

    // 🔹 PROJECT DESCRIPTION SECTION
    description: {
      intro:
        "Birla Trimaya Phase 2 is a premium integrated township by Birla Estates located in the fast-growing Devanahalli–Shettigere corridor of North Bangalore",

      highlights: [
        "B + G + 12 Floors",
        "8 Towers across 7.34 Acres",
        "Spacious 2, 3 & 4 BHK Residences"
      ],

      configurations: [
        "1 BHK – 551 sft",
        "2 BHK – 827-870 sft",
        "3 BHK – 1029-1100 sft",
        "3.5 BHK – 1178-1213 sft",
        "4 BHK – 2175-3119 sft"
      ],

      price: "1.3 Cr onwards"
    },
    summary: [
      { label: "Project Name", value: "Birla ", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1250/303/PR/040924/006988",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Birla Estates", icon: "Home" },
      {
        label: "Structure Type",
        value: "RCC Framed  Structure 12-13 Floors",
        icon: "Car"
      },
      { label: "Total Land Area", value: "7.34 Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "75%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "13", icon: "Layers" },
      { label: "Units", value: "473", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & multipurpose hall"
          },
          // { icon: "Film", title: "Mini Theatre", desc: "Private cinema experience" },
          { icon: "Coffee", title: "Terrace Café", desc: "Casual dining space" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          { icon: "Waves", title: "Swimming Pool", desc: "Adult & kids pool" },
          {
            icon: "Activity",
            title: "Sports Courts",
            desc: "Tennis Court & basketball"
          },
          // { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  },

  //Brigade

  {
    slug: "jayram-horizon-homes",
    title: "Brigade Group",
    location: "Devanahalli",
    image: bg1,
    topTag: "Possession: 2028 Onwards",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [bg2, bga1, bga2, bga3, bga4],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Brigade Ebony is a premium residential apartment project by Brigade Group located in Kalyan Nagar, North Bangalore.",

        "Designed to offer a blend of comfort and modern urban living, the development features spacious 2 and 3 BHK apartments with well-planned layouts, ample natural light, and quality finishes.",
        "The project includes a range of lifestyle amenities such as a clubhouse, swimming pool, gymnasium, landscaped gardens, children’s play area, and 24/7 security, creating a safe and community-focused environment.",
        "Its strategic location provides easy access to major IT hubs, schools, hospitals, shopping centers, and key road networks, making it an ideal choice for families and professionals seeking convenience and connectivity."
      ]
    },
    description: {
      intro:
        "The residential enclave Brigade Orchards Ebony is the newest phase of the landmark 135-acre smart township that features the absolute best in Brigade Group’s luxury living segment",

      highlights: [
        "2B + G + 18 Floors",
        "8 Towers across 14 Acres",
        "Spacious 2, 3 & 4 BHK Residences"
      ],

      configurations: [
        "2 BHK – 1200 sft",
        "3 BHK – 1750–1850 sft",
        "4 BHK – 2200–2600 sft"
      ],

      price: "1.35 Cr onwards"
    },
    summary: [
      { label: "Project Name", value: "Brigade Ebony", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1250/303/PR/280225/007530",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Brigade Group", icon: "Home" },
      {
        label: "Structure Type",
        value: " G + 8 Floors - 4Towers",
        icon: "Car"
      },
      { label: "Total Land Area", value: "3.2Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "80%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "8", icon: "Layers" },
      { label: "Units", value: "232", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & Tabel Tennis caroom"
          },
          {
            icon: "Film",
            title: "Mini Theatre",
            desc: "Private cinema experience"
          },
          { icon: "Coffee", title: "Terrace Café", desc: "Casual dining space" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          {
            icon: "Waves",
            title: "Reflexology Walkway",
            desc: "Walkway             "
          },
          {
            icon: "Activity",
            title: "Park",
            desc: "Kid's Play Area && Seating Pavillon"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  },


 

  {
    slug: "Godrej-Parkshire-homes",
    title: "Godrej Parkshire",
    location: " Hoskote, off Whitefield",
    image: go1,
    topTag: "Possession:  Dec 2030 Onwards",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [go12, goa2, goa3, goa4, goa5],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Godrej Parkshire is a premium residential development designed to offer a perfect blend of modern living and natural serenity. ",

        "Thoughtfully planned with contemporary architecture, lush green landscapes, and world-class amenities, the project creates an ideal environment for families seeking comfort, convenience, and luxury. Featuring spacious homes with smart layouts, abundant natural light, and high-quality finishes, Godrej Parkshire ensures a refined lifestyle experience.",
        "With excellent connectivity to key city hubs, educational institutions, healthcare facilities, and entertainment zones, it delivers both tranquility and urban accessibility, making it a perfect address for your dream home."
      ]
    },
    description: {
      intro:
        "Godrej Parkshire is the new premium luxury residential apartment project in Hoskote, off Whitefield, East Bangalore.",

      highlights: [
        "  2B + G + 28 Floors",
        "5 Towers across 13.5 Acres",
        "Spacious 2, 3  BHK Residences"
      ],

      configurations: ["2 BHK Premium– 1050 sft", "2 BHK Luxe 1200 sft", "3 BHK Premium– 1600 sft","3 BHK Luxe 1850 sft",],

      price: "1.12 Cr onwards"
    },
    summary: [                                                                          
      { label: "Project Name", value: "Godrej Parkshire", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1250/304/PR/090126/008393",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Godrej Properties", icon: "Home" },
      {
        label: "Structure Type",
        value: " 2B + G + 28 Floors - 5Towers",
        icon: "Car"
      },
      { label: "Total Land Area", value: "13.5Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "80%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "8", icon: "Layers" },
      { label: "Units", value: "1132", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & Tabel Tennis caroom"
          },
          {
            icon: "Film",
            title: "Mini Theatre",
            desc: "Private cinema experience"
          },
          { icon: "Coffee", title: "Terrace Café", desc: "Casual dining space" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          {
            icon: "Waves",
            title: "Swimming Pool",
            desc: "Lush swimming pool with water features"
          },
          {
            icon: "Activity",
            title: "Park",
            desc: "Kid's Play Area & Seating Pavillon, Pet Park"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  },

   {
    slug: "Century-Regalia-homes",
    title: "Century Regalia",
    location: " Indiranagar, Old Airport Road",
    image: Century1,
    topTag: "Possession:  April 2029 Onwards",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [Century2, Century3, Century4, Century5, Century6],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "The Century Regalia Project is a creative and cultural initiative focused on designing and presenting ceremonial attire that represents a hundred years of heritage, achievement, and identity. ",

        "The project combines historical research, artistic design, and symbolic elements to create regalia that reflects tradition, unity, and progress over a century. It highlights significant milestones, honors past leaders and contributors, and showcases craftsmanship through carefully selected colors, fabrics, patterns, and emblems that embody the values and legacy of the institution or community. Through exhibitions, documentation, and presentations, the Century Regalia Project aims to preserve history, inspire pride, and celebrate a century of excellence for future generations.",
      ]
    },
    description: {
      intro:
        "Century Regalia’s residential enclave is the epitome of fine living at the heart of Bangalore and features the very best in Century Real Estate’s luxury living segment.",

      highlights: [
        "2B + G + 11 Floors",
        " 2 Towers across    8.5  Acres",
        "3,4 BHK, Imperial Residences"
      ],

      configurations: ["2 BHK Premium– 1050 sft", "2 BHK Luxe 1200 sft", "3 BHK Premium– 1600 sft","3 BHK Luxe 1850 sft",],

      price: "5.35 Cr onwards"
    },
    summary: [                                                                          
      { label: "Project Name", value: "Century Regalia", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1251/446/PR/170524/006883",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Century", icon: "Home" },
      {
        label: "Structure Type",
        value: " 2B + G + 11 Floors - 2Towers",
        icon: "Car"
      },
      { label: "Total Land Area", value: "3.5Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "80%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "11", icon: "Layers" },
      { label: "Units", value: "300", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & Tabel Tennis caroom"
          },
          {
            icon: "Film",
            title: "Mini Theatre",
            desc: "Private cinema experience"
          },
          { icon: "Coffee", title: "Terrace Café", desc: "Casual dining space" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          {
            icon: "Waves",
            title: "Swimming Pool",
            desc: "Lush swimming pool with water features"
          },
          {
            icon: "Activity",
            title: "Park",
            desc: "Kid's Play Area & Seating Pavillon, Pet Park"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  } ,
    {
    slug: "Assetz-homes",
    title: " Assetz",
    location: "Bagalur Main Road",
    image: Assets1,
    topTag: "Possession:Dec 2028 Onwards",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [Assets2, Assets3, Assets4],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Concorde Neo is a premium residential project designed to redefine modern urban living through a seamless blend of contemporary architecture, thoughtful planning, and world-class amenities.",

        "Strategically located for excellent connectivity and everyday convenience, the project offers elegantly crafted homes with smart layouts, abundant natural light, and superior finishes that reflect comfort and sophistication.",
        "Residents enjoy a vibrant lifestyle supported by landscaped open spaces, a fully equipped clubhouse, fitness center, swimming pool, children’s play areas, and dedicated zones for relaxation and recreation.    With a focus on quality, sustainability, and community living, Concorde Neo provides an ideal environment for families seeking a harmonious balance of tranquility and urban accessibility in their dream home.",
        "Built with a focus on quality, sustainability, and security, Concorde Neo creates a harmonious community where luxury meets functionality, making it the ideal address for families seeking a refined and future-ready living experience."
      ]
    },
    description: {
      intro:
        "The residential enclave Concorde Neo is the best in Concorde Group’s luxury living segment. The project offers spacious 2 & 3 BHK Apartments with luxurious features.",

      highlights: [
        "2B + G + 14Floors",
        " 6 Towers across    4.2  Acres",
        "2,3, BHK"
      ],

      configurations: ["3 BHK  2159  sq.ft.", "4 BHK 2955 sq.ft.",],

      price: "1.03 Cr onwards"
    },
    summary: [                                                                          
      { label: "Project Name", value: "Assetz Zen & sato", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1251/472/PR/080525/007728",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Assetz", icon: "Home" },
      {
        label: "Structure Type",
        value: " 2B + G + 14 Floors",
        icon: "Car"
      },
      { label: "Total Land Area", value: "7 Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "74%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "14", icon: "Layers" },
      { label: "Units", value: "412", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & Tabel Tennis caroom"
          },
          {
            icon: "Film",
            title: "Mini Theatre",
            desc: "OPEN-AIR THEATRE"
          },
          { icon: "Coffee", title: "Terrace Café", desc: "Casual dining space" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          {
            icon: "Waves",
            title: "Swimming Pool",
            desc: "Lush swimming pool with water features"
          },
          {
            icon: "Activity",
            title: "Park",
            desc: "Kid's Play Area & Seating Pavillon, Pet Park"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  } ,
    {
    slug: "puravankara-homes",
    title: "Puravankara",
    location: "Electronic",
    image: puvankar1,
    topTag: "Possession:June 2030",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [puvankar2, puvankarAminities1, puvankarAminities2,puvankarAminities3,puvankarAminities4],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Purva Silversky located in Hebbagodi, Apartments in Electronic City — a tranquil sanctuary designed for those who seek to balance ambition and ease, connection and calm. Spread across 6.99 acres and envisioned by Hafeez Contractor, this community offers an environment where work and life flow in harmony. A space where life slows, breathes, and finds its perfect rhythm.",

        " With just 356 exclusive residences, Purva Silversky celebrates low-density living and the rare luxury of space, privacy, and serenity in the heart of Bengaluru’s tech corridor.",
        "Expansive greens, wellness-inspired amenities, and contemporary architecture come together to create a home that restores as much as it inspires.Here, balance isn’t an idea. It’s a way of livin.",
        "Zen and Sato represents more than a project; it is a refined expression of strategic thinking, creativity, and precision working together to build meaningful digital presence."
      ] 
    },
    description: {
      intro:
        "Purva Silversky located in Hebbagodi, Apartments in Electronic City — a tranquil sanctuary designed for those who seek to balance ambition and ease, connection and calm. Spread across 6.99 acres and envisioned by Hafeez Contractor, this community offers an environment where work and life flow in harmony.",

      highlights: [
        "G + 32Floors 56 apartments",
        " 3 Towers across  6.99  Acres",
        "2,3,4 BHK + M"
      ],

      configurations: ["3 BHK  1,864 - 2,042  sq.ft.",   "3 BHK + M 2,300 - 2,302", "4 BHK + M 2,824 - 4,272 sq.ft.",],

      price: "2.30 Cr onwards"
    },
    summary: [                                                                          
      { label: "Project Name", value: "puravankara-homes", icon: "Building2" },
      {
        label: "RERA No",
        value: "RERA NO: PRM/KA/RERA/1251/310/PR/151225/008338",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "puravankara", icon: "Home" },
      {
        label: "Structure Type",
        value: "G + 32Floors 56 apartments",
        icon: "Car"
      },
      { label: "Total Land Area", value: "6.99", icon: "LandPlot" },
      { label: "Open Space Area", value: "74%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "32", icon: "Layers" },
      { label: "Units", value: "356", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & Tabel Tennis caroom , Pickleball, Badminton"
          },
          {
            icon: "Activity",
            title: "Event Plaza",
            desc: "Snooker Gardens"
          },
          { icon: "Coffee", title: "Terrace Café", desc: "Casual dining space" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          {
            icon: "Waves",
            title: "Swimming Pool",
            desc: "Lush swimming pool with water features"
          },
          {
            icon: "Activity",
            title: "Park",
            desc: "Kid's Play Area & Seating Pavillon, Pet Park ,Treehouse Walk ,Climbing Wall,Play Zone,Hobbit House"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  },

  {
    slug: " Concorde-Neo-homes",
    title: " Concorde Neo",
    location: " Thanisandra",
    image: ConcordeNeo1,
    topTag: "Possession:   Dec 2028 Onwards",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [ConcordeNeo2, ConcordeNeo3, ],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Concorde Neo is a premium residential project designed to redefine modern urban living through a seamless blend of contemporary architecture, thoughtful planning, and world-class amenities.",

        "Strategically located for excellent connectivity and everyday convenience, the project offers elegantly crafted homes with smart layouts, abundant natural light, and superior finishes that reflect comfort and sophistication.",
        "Residents enjoy a vibrant lifestyle supported by landscaped open spaces, a fully equipped clubhouse, fitness center, swimming pool, children’s play areas, and dedicated zones for relaxation and recreation.    With a focus on quality, sustainability, and community living, Concorde Neo provides an ideal environment for families seeking a harmonious balance of tranquility and urban accessibility in their dream home.",
        "Built with a focus on quality, sustainability, and security, Concorde Neo creates a harmonious community where luxury meets functionality, making it the ideal address for families seeking a refined and future-ready living experience."
      ]
    },
    description: {
      intro:
        "The residential enclave Concorde Neo is the best in Concorde Group’s luxury living segment. The project offers spacious 2 & 3 BHK Apartments with luxurious features.",

      highlights: [
        "G + 18 Floors",
        " 6 Towers across    4.2  Acres",
        "2,3, BHK"
      ],

      configurations: ["2 BHK + 2T  1107 to 1241 sq.ft.", "3 BHK +2T 1477 to 1490 sq.ft.", "3 BHK +3T 1539 sq.ft.",],

      price: "1.03 Cr onwards"
    },
    summary: [                                                                          
      { label: "Project Name", value: "Concorde Neo", icon: "Building2" },
      {
        label: "RERA No",
        value: "PRM/KA/RERA/1251/309/PR/270924/007088                   ",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Concorde Neo", icon: "Home" },
      {
        label: "Structure Type",
        value: " 2B + G + 11 Floors - 2Towers",
        icon: "Car"
      },
      { label: "Total Land Area", value: "4.2 Acres", icon: "LandPlot" },
      { label: "Open Space Area", value: "78%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "11", icon: "Layers" },
      { label: "Units", value: "300", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & Tabel Tennis caroom"
          },
          {
            icon: "Film",
            title: "Mini Theatre",
            desc: "OPEN-AIR THEATRE"
          },
          { icon: "Coffee", title: "Terrace Café", desc: "Casual dining space" }
        ]
      },
      {
        category: "Outdoor & Sports Amenities",
        items: [
          {
            icon: "Waves",
            title: "Swimming Pool",
            desc: "Lush swimming pool with water features"
          },
          {
            icon: "Activity",
            title: "Park",
            desc: "Kid's Play Area & Seating Pavillon, Pet Park"
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  } ,





  {
    slug: "vaishnavi-devi",
    title: "Vaishnodevi Melange Oneis ",
    location: "Rajarajeshwari Nagar",
    image: Vaishnavidevi1,
    topTag: "Possession:June 2030",
    imageTag: "Premium",
    status: "Featured",
    statusType: "featured",
    Brochure: [Brochure1],
    img: [Prestige2,Prestigeamenities3,Prestigeamenities1,Prestigeamenities2],
    overview: {
      heading: "About the Project",
      paragraphs: [
        "Vaishnodevi Melange Oneis a premium ultra-luxury apartment project in Rajarajeshwari Nagar, Bangalore. The project offers 3 BHK & 4 BHK Sky Villa homes.",

        "These homes feel like private villas in the sky. The project has only 120 homes, which gives more privacy and peace. It has one tall tower with 3 basement levels, ground floor, and 32 floors. Each home is large, bright, and open ",
        "EThere are no shared walls, so homes stay quiet. The project is also known as Codename Olympus and offers a modern SOHO lifestyle in Bangalore.",
        "Vaishnodevi Melange One is located in Rajarajeshwari Nagar, Bengaluru. The project is just 200 meters from RR Nagar Metro Station. This makes daily travel fast and easy. The area is calm and green. Schools, hospitals, malls, and offices are nearby. It is a good place for families and working professionals.",
        "The project has strong road and metro connectivity. Major city roads are close by. Daily travel to work, school, and shopping is easy. The metro station near the project helps save time and effort. Rajarajeshwari Nagar is one of the fast-growing areas in West Bangalore."
      ] 
    },
    description: {                  
      intro:"Vaishnodevi Melange Oneis a premium ultra-luxury apartment project in Rajarajeshwari Nagar, Bangalore. The project offers 3 BHK & 4 BHK Sky Villa homes.",

      highlights: [
        "3B + Ground + 32 Floors",
        "1 Towers across  1.43 Acres",
        "3 & 4 BHK"
      ],

      configurations: ["2 BHK  1,200 sq.ft.",   "3 BHK 1,500 -2015 sq.ft." , "4 BHK 2300-2500 sq.ft",],

      price: "3.5 Cr onwards"
    },
    summary: [                                                                          
      { label: "Project Name", value: "Vaishnodevi Melange Oneis", icon: "Building2" },
      {
        label: "RERA No",
        value: "RERA NO: PRM/KA/RERA/1251/310/PR/230126/008425",
        icon: "FileCheck2"
      },
      { label: "Developer", value: "Vaishnodevi ", icon: "Home" },
      {
        label: "Structure Type",
        value: "3B + G+  + 19Floors ",
        icon: "Car"
      },
      { label: "Total Land Area", value: "1.423", icon: "LandPlot" },
      { label: "Open Space Area", value: "75%", icon: "TreePine" },
      {
        label: "Construction Stage",
        value: "Under Construction",
        icon: "Hammer"
      },
      { label: "Floors", value: "3B+G+32 Floors ", icon: "Layers" },
      { label: "Units", value: "120", icon: "Building2" }
    ],
    amenities: [
      {
        category: "Indoor Amenities",
        items: [
          {
            icon: "Building2",
            title: "Clubhouse",
            desc: "Grand clubhouse with social spaces"
          },
          {
            icon: "Dumbbell",
            title: "Fitness & Wellness",
            desc: "Gym & yoga deck"
          },
          {
            icon: "Gamepad2",
            title: "Indoor Games",
            desc: "Games & Tabel Tennis caroom , Pickleball, Badminton"
          },
          { icon: "Film", title: "Mini Theatre", desc: "Private cinema experience" },

          { icon: "Coffee", title: "CC Tv Secuity ", desc: "24/7 CC Tv Monitering " }
        ]
      },                  
      {
        category: "Outdoor & Sports Amenities",
        items: [
          {
            icon: "Waves",
            title: "Swimming Pool",
            desc: "Lush swimming pool with water features"
          },
          {
            icon: "Activity",
            title: "Park",
            desc: "Kid's Play Area , Park "
          },
          { icon: "Map", title: "Jogging Track", desc: "Green jogging paths" },
          {
            icon: "Leaf",               
            title: "Landscaped Gardens",
            desc: "Open green zones"
          }
        ]
      }
    ]
  } 




];
